import Badge from 'components/Badge';
import { PhoneCellWrapper } from './styled';

interface Props {
    value?: string;
}

const PhoneTypeColumn = ({ value = '' }: Props) => {
    const isEmpty = !value || value === '';
    if (isEmpty) return null;
    return (
        <PhoneCellWrapper>
            <Badge label={value} size="small" />
        </PhoneCellWrapper>
    );
};

export default PhoneTypeColumn;
